<template>
  <v-app-bar app dense clipped-left class="white">
    <v-btn
      icon
      class="mx-2 d-lg-none"
      @click="$emit('drawer')"
      data-cy="drawer"
    >
      <v-icon>mdi-menu</v-icon>
    </v-btn>
    <v-btn text @click.native="navigateBase" data-cy="logo">
      <v-img
        src="../assets/logo.png"
        max-height="80"
        max-width="120"
        contain
      ></v-img>
    </v-btn>
    <v-spacer></v-spacer>
    <slot name="left"></slot>
    
    <BaseUserMenu v-bind="$attrs" v-on="$listeners"/>
  </v-app-bar>
</template>

<script>
import BaseUserMenu from "./BaseUserMenu.vue";

export default {
  props: {
    logoNavigationUrl: {
      type: String,
      default: "https://" + window.location.host + "/"
    }
  },
  components: { BaseUserMenu },
  methods: {
    logout() {
      this.$router.push("/");
      this.keycloak.logout();
    },
    navigateBase() {
        window.location = this.logoNavigationUrl;
      }
    },
};
</script>

<style scoped>
* {
  text-transform: none !important;
}
</style>
